import { api, LightningElement } from "lwc";
import { getAssetsUrl } from "common/helpers";

export default class extends LightningElement {
  @api fonts = false;

  connectedCallback() {
    if (this.fonts) appendStyleSheet(getAssetsUrl("/css/tds.css"));
  }
}

export function appendStyleSheet(href: string) {
  let exists = Array.from(document.querySelectorAll("link")).some(
    (n) => n.getAttribute("href") === href
  );
  if (exists) return;
  document.head.appendChild(
    (() => {
      let element = document.createElement("link");
      element.href = href;
      element.rel = "stylesheet";
      element.type = "text/css";
      return element;
    })()
  );
}
